import {
    FINANCIAL_ADVISER_PENSION_TRANSFERS_SPECIALIST_ID,
    FINANCIAL_ADVISER_PENSION_TRANSFERS_NON_SPECIALIST_ID,
} from '../__constants__';
import { getWealthDropdownOptions } from './getDropdownOptions';
import { getWealthLevelIds } from './attributeHelper';


const pensionTransfersId = {
    specialist: FINANCIAL_ADVISER_PENSION_TRANSFERS_SPECIALIST_ID,
    nonSpecialist: FINANCIAL_ADVISER_PENSION_TRANSFERS_NON_SPECIALIST_ID,
};

export const formatSearchLocationParam = location => {
    let newLocation = location;

    if (location.includes('%20')) {
        newLocation = location.replace('%20', ' ');
    }

    return newLocation.trim();
};

export const formatSearchLocationText = location => {
    const capitaliseFirstChar = string => string.charAt(0).toUpperCase() + string.substring(1);

    if (!location) return '';

    return location.toLowerCase()
        .replace('%20', ' ')
        .split(' ')
        .map(s => capitaliseFirstChar(s))
        .join(' ')
        .split('-')
        .map(s => capitaliseFirstChar(s))
        .join('-');
};

export const getParentListStateForPensionTransfersService = (pensionTransferId, serviceIds) => {
    const { specialist, nonSpecialist } = pensionTransfersId;

    if (!serviceIds.includes(specialist) && !serviceIds.includes(nonSpecialist)) {
        return [pensionTransferId, ...serviceIds];
    }

    const filteredServices = serviceIds.filter(id =>
        id !== specialist &&
        id !== nonSpecialist
    );

    return [pensionTransferId, ...filteredServices];
};

export const calculateMortgageAdviserFilterState = (nextMortgageAdviserValue) => {
    const wealthLevelIds = getWealthDropdownOptions(nextMortgageAdviserValue);
    const initialWealthValue = wealthLevelIds[0].id;

    return {
        wealth: initialWealthValue,
        wealth_level_ids: getWealthLevelIds(initialWealthValue, nextMortgageAdviserValue),
    };
};
